/**
 * The glyph drawn in an opening whose asset the manifest cannot find (rule 12 of
 * as2047-configuration-viewer-acceptance.md, D-150): a question mark.
 *
 * A stored drawing names its glyphs by id, and the drawing set is versioned apart from
 * the drawings that use it, so a saved drawing can name an id the manifest no longer (or
 * never) held. The architect, 2026-09-30: "we do not want errors when we dont find a
 * match. create an svg for unknown "?" to inject on things we cant find. dont error".
 * So the opening draws this in the glyph's place, the rest of the drawing renders as
 * usual, and nothing throws.
 *
 * Why it is a constant here and not a file in assets/svg: it must never be offered, and
 * every file in that folder is a manifest entry the asset browser lists
 * (AssetManifestParity); and it is the fallback for a lookup that already failed, so it
 * must not depend on a fetch that could fail in turn. It follows the set's authoring
 * rules all the same (assets/svg/DESIGN-HANDOFF.md): the root element verbatim, one
 * comment stating what it draws, and line geometry only. It carries no label: the labels
 * of the set come from the manifest entry, and an unknown id has none, so the question
 * mark stands in for glyph and label both.
 */
export const UNKNOWN_ASSET_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 152" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="butt" stroke-linejoin="round">
  <!-- Unknown asset: a question mark, drawn where the manifest holds no entry for the opening's asset id. Centred and clear of the edges, like a travel arrow, because it marks the opening rather than an operation. -->
  <path d="M 30,54 C 30,24 70,24 70,54 C 70,74 50,74 50,94 L 50,106"/>
  <line x1="50" y1="116" x2="50" y2="128"/>
</svg>`;
